import { KSelectOption } from "kahuna-base-react-components/dist/components/KDropdown/KDropdown"
import { UserTakedown } from "../../../../types"

export const TakedownProcessStatusOptionList: KSelectOption[] = [
  { label: "Not Started", value: 1, value2: "not_started" },
  { label: "Preparing Metadata", value: 2, value2: "preparing_metadata" },
  { label: "Audio Download", value: 3, value2: "audio_download" },
  { label: "Audio Asset Upload", value: 4, value2: "audio_asset_upload" },
  { label: "Match Pending", value: 5, value2: "match_pending" },
  { label: "Takedown In Progress", value: 6, value2: "takedown_in_progress" },
  { label: "Payment In Progress", value: 7, value2: "payment_in_progress" },
  { label: "Closed", value: 8, value2: "closed" }
]

export const getTakedownProcessStatusLabel = (status?: string) => {
  return TakedownProcessStatusOptionList.find((option) => option.value2 === status)?.label || status || "-"
}

export const formatTakedownStatusLogDate = (date?: string) => {
  return date ? date.replace("T", " ").substring(0, 16) : "-"
}

export const TAKEDOWN_DEAL_TYPE = { ADVANCE: "advance", DISTRO_ONLY: "distro_only" }

const TAKEDOWN_DEAL_TYPE_LABELS: Record<string, string> = {
  [TAKEDOWN_DEAL_TYPE.ADVANCE]: "Advance",
  [TAKEDOWN_DEAL_TYPE.DISTRO_ONLY]: "Distro Only"
}

export const getTakedownDealTypeLabel = (dealType?: string) => {
  return (dealType && TAKEDOWN_DEAL_TYPE_LABELS[dealType]) || "-"
}

// Stages the whole process goes through; distro only deals close right after the takedown, with no payment stage
const getTakedownProcessSteps = (dealType?: string) => {
  return TakedownProcessStatusOptionList.map((option) => option.value2 as string).filter(
    (status) =>
      status !== "not_started" && !(dealType === TAKEDOWN_DEAL_TYPE.DISTRO_ONLY && status === "payment_in_progress")
  )
}

/**
 * Share of the whole takedown done, by steps: finished stages count fully and the current one by its own progress
 */
export const getTakedownOverallProgress = (takedown: UserTakedown) => {
  const steps = getTakedownProcessSteps(takedown.dealType)
  const status = takedown.takedownProcessStatus
  if (status === "closed") return { percent: 100, step: steps.length, stepCount: steps.length }

  const stepIndex = steps.indexOf(status)
  if (stepIndex < 0) return { percent: 0, step: 0, stepCount: steps.length }

  // A failed stage keeps its progress for the timeline but has not moved the takedown on
  const stageProgress =
    takedown.currentStatusLog?.result === "failed"
      ? 0
      : Math.max(0, Math.min(100, takedown.currentStatusLog?.progress || 0))
  const percent = Math.round(((stepIndex + stageProgress / 100) / steps.length) * 100)
  return { percent, step: stepIndex + 1, stepCount: steps.length }
}
